import { useState } from "react";

const FORM_ENDPOINT = "https://readdy.ai/api/form/db973igkk00l6eltrppg";

export default function ContactForm() {
  const [status, setStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [feedback, setFeedback] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (status === "submitting") return;

    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setFeedback("留言已提交，感谢你的反馈！");
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      const text = String(value).trim();
      if (text) payload.append(key, text);
    });

    if (!payload.get("name") || !payload.get("email") || !payload.get("message")) {
      setStatus("error");
      setFeedback("请完整填写姓名、邮箱与留言内容后再提交。");
      return;
    }

    setStatus("submitting");
    setFeedback("");
    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText || "";
      const isSpam = String(serverMsg).toLowerCase().includes("spam");
      const ok = response.ok && parsed?.code === "OK" && !isSpam;

      if (ok) {
        setStatus("success");
        setFeedback("留言已提交，感谢你的反馈！我们会尽快查看。");
        form.reset();
      } else {
        setStatus("error");
        setFeedback(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFeedback("网络异常，提交失败，请稍后重试。");
    }
  };

  return (
    <form
      id="db973igkk00l6eltrppg"
      data-readdy-form
      onSubmit={handleSubmit}
      className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 space-y-4"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="contact-name" className="block text-sm text-foreground-600 mb-1.5">
            姓名
          </label>
          <input
            id="contact-name"
            name="name"
            type="text"
            required
            placeholder="请输入你的称呼"
            className="w-full h-11 px-3.5 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-accent-500 transition-colors"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm text-foreground-600 mb-1.5">
            邮箱
          </label>
          <input
            id="contact-email"
            name="email"
            type="email"
            required
            placeholder="请输入你的邮箱"
            className="w-full h-11 px-3.5 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-accent-500 transition-colors"
          />
        </div>
      </div>

      <div>
        <label htmlFor="contact-message" className="block text-sm text-foreground-600 mb-1.5">
          留言内容
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="欢迎留下你的建议、想看的内容或合作意向（最多 500 字）"
          className="w-full px-3.5 py-3 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-accent-500 transition-colors resize-none"
        />
      </div>

      <input
        type="text"
        name="website_alt"
        className="field-guard-extra"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      {feedback && (
        <p
          className={`text-sm ${status === "success" ? "text-secondary-700" : "text-accent-700"}`}
          role="status"
        >
          {feedback}
        </p>
      )}

      <button
        type="submit"
        disabled={status === "submitting"}
        className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-500 disabled:opacity-60 disabled:cursor-not-allowed transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-send-plane-line"></i>
        {status === "submitting" ? "提交中..." : "提交留言"}
      </button>
    </form>
  );
}